module.exports = __webpack_public_path__ + "static/media/weight.b4d16c08.svg";